import { ReactNode } from 'react'
import { Provider } from 'react-redux'
import { applicationDataStore } from '.'

export interface AppStoreProviderProps {
  children: ReactNode
}

export default function AppStoreProvider(props: AppStoreProviderProps) {
  return <Provider store={applicationDataStore}>{props.children}</Provider>
}
